<template>
  <div class="questionStock">
    <div class="onlineNav">
      <headers class="herderNav" ref="header" :isChange="false" />
      <div class="searchNav">
        <h1>海量GMAT题库 · 做题搜题一网打尽</h1>
        <div class="titTag">
          <a class="scoreTag">题库总题数9k+</a><a>模考仿真度99%</a
          ><a class="scoreLast">题库更新频率day by day</a>
        </div>
        <div class="searchInput">
          <input
            placeholder="搜索包括不限于以下题源：OG PREP破解版（07/08/12） GWD Manhattan Advanced 300 杨鹏长难句……等市面全部主流题源"
            @click="goSearch"
          />
        </div>
        <div class="searchText">
          部分题源会配备真人视频逐题讲解哦，做GMAT，我们是用心的
        </div>
      </div>
    </div>
    <div class="stockCon">
      <div class="stockConBox">
        <div class="stockNav">
          <ul>
            <li
              v-for="(ele, index) in switchTab"
              :key="index"
              :class="oneClassIndex === index ? 'active' : ''"
              @click="switchTabs(ele.id, index)"
            >
              {{ ele.name }}
            </li>
          </ul>
        </div>
        <div class="stockBoxText">
          <ul>
            <li
              v-for="(item, indexs) in titles"
              :key="indexs"
              :class="twoClassIndex == indexs ? 'activeTit' : ''"
              @click="switchTit(item.type, indexs)"
            >
              {{ item.name }}
            </li>
          </ul>
          <div v-if="openId" class="stockBoxTextTag">
            <button
              class="tagBtn"
              v-for="(tag, index) in allTag"
              :key="index"
              :class="threeClassIndex == index ? 'activeTag' : ''"
              @click="switchTag(tag.id, index)"
            >
              {{ tag.title }}
            </button>
          </div>
          <!-- 二级 知识点 -->
          <div v-if="!openId" class="stockBoxTextTag">
            <button
              class="tagBtn"
              v-for="(tag, index) in knowles"
              :key="index"
              :class="knowlesTabIndex == index ? 'activeTag' : ''"
              @click="knowlesTabs(tag.id, index)"
            >
              {{ tag.title }}
            </button>
          </div>
        </div>
        <p class="topic_list_title">题目列表</p>
        <div class="sbujectList">
          <div class="sbujectListCon">
            <div
              style="cursor: pointer"
              v-for="(eles, index) in allSubject"
              :key="index"
              @click="go(eles)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/subject.js";
import headers from "../../components/header.vue";
import searchNav from "../../components/searchNav.vue";
export default {
  components: {
    searchNav,
    headers,
  },
  data() {
    return {
      navCodes: require("@/assets/login/whiteCode.png"),
      headerIcon: require("@/assets/bottom/bottomIcon.png"),
      n: null,
      oneClassIndex: 0,
      twoClassIndex: 0,
      threeClassIndex: 0,
      m: null,
      //一级tab
      switchTab: [],
      // 二级
      openId: true,
      titles: [
        {
          name: "题库来源",
          type: 1,
        },
        {
          name: "关联知识点",
          type: 2,
        },
      ],
      //标签
      allTag: [],
      //题目列表
      allSubject: [],
      //知识点
      knowles: [],
      knowlesTabIndex: 0
    };
  },
  methods: {
    goSearch() {
      this.$router.push("/searchMatter");
    },
    //一级tab
    switchTabs(ids, index) {
      this.n = ids;
      this.oneClassIndex = index;
      this.threeClassIndex = 0;
      this.twoClassIndex = 0;
      this.knowlesTabIndex = 0;
      this.openId = true;
      this.m = null;
      this.getSubject().then((res) => {
        let that = this;
        that.getSubject()
      });
    },
    //按钮标签
    switchTit(ids, index) {
      this.twoClassIndex = index;
      this.m = ids;
      if (ids == 1) {
        this.openId = true;
      } else {
        this.openId = false;
      }
      this.getSubject()
      // console.log('zz',ids,index)
    },
    switchTag(type, index) {
      this.threeClassIndex = index;
      this.m = type;
      this.getSubject()
    },
    knowlesTabs(id, index) {
      this.knowlesTabIndex = index;
      this.getSubject()
    },
    go(ids) {
      this.$router.push(`libraryContent/${ids}`);
    },
    //获取题库列表
    getSubject() {
      this.allSubject = [];
      let params = {
        page: 1,
        limit: 10,
        c_id: this.n,
        t_id: this.m,
        k_id: "",
      };
      if (this.openId) {
        params.k_id = "";
        if (this.allTag.length > 0) {
          params.t_id = this.allTag[this.threeClassIndex].id;
        }
      } else {
        params.t_id = "";
        params.k_id = this.knowles[this.knowlesTabIndex].id;
      }
      let query = this.$qs.stringify(params);
      return api
        .getTopic(query)
        .then((res) => {
          this.allTag = res.data.data.textbooks;
          this.switchTab = res.data.data.courses;
          this.allSubject = res.data.data.topics;
          this.knowles = [
            {
              id: 0,
              title: "全部",
            },
          ].concat(res.data.data.knowles);
          return Promise.resolve();
        })
        .catch((err) => {
          this.$message.error("数据请求失败请重试");
        });
    },
  },
  created() {
    this.getSubject().then((res) => {
      console.log(res);
      this.n = this.switchTab[0].id;
      this.oneClassIndex = 0;
      this.threeClassIndex = 0;
      this.twoClassIndex = 0;
      this.knowlesTabIndex = 0;
      this.openId = true;
      this.m = null;
      this.getSubject().then((res) => {
        this.getSubject()
      });
    });
  },
  mounted() {
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
  },
};
</script>

<style scoped>
@import url("../../assets/css/questionStock.css");
</style>



// WEBPACK FOOTER //
// src/view/questionBank/questionStock.vue